import { orderBy } from "lodash";
import { Api } from "queries/types";
import { useQuery } from "react-query";
import { get } from "./http";

const useSectorManagersIndex = () =>
  useQuery<Api.SectorManager[]>(["sector_managers"], () => get("/merch_users/sector_managers"), {
    select: (data) => orderBy(data, "fullName"),
  });

export { useSectorManagersIndex };
